import React, { useState, useEffect } from 'react';
import TenantsWithCommentBlock from '../../../TenantsWithCommentBlock/TenantsWithCommentBlock';
import useCurrentAddress from '../../../../../hooks/useCurrentAddress';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import AddTenantModal from '../../../modals/AddTenantModal/AddTenantModal';
import { texts } from '../../../../../constants/texts';

const FlatsExpandedRow = ({ record = {}, queryKeys }) => {
  const [currentTenant, setCurrentTenant] = useState(null);

  const {
    visible: addTenantModalVisible,
    showModal: showAddTenantModal,
    hideModal: hideAddTenantModal,
  } = useChangeModalVisible();

  const address = useCurrentAddress();

  const handleChangeButtonClick = (tenant) => {
    showAddTenantModal();
    setCurrentTenant(tenant);
  };

  const handleCancel = () => {
    setCurrentTenant(null);
    hideAddTenantModal();
  };

  useEffect(() => {
    if (currentTenant) {
      const updatedTenant = record.clients.find(
        (t) => t.id === currentTenant.id
      );
      if (updatedTenant && updatedTenant !== currentTenant) {
        setCurrentTenant(updatedTenant);
      }
    }
  }, [record.clients]);

  return (
    <>
      <TenantsWithCommentBlock
        tenants={record.clients}
        onChangeButtonClick={handleChangeButtonClick}
        changeButtonText={`${texts.edit}/${texts.delete}`}
        addressId={record.addressId}
      />
      <AddTenantModal
        visible={addTenantModalVisible}
        onCancel={handleCancel}
        address={address}
        addressId={record.addressId}
        initialValues={currentTenant}
        queryKeys={queryKeys}
      />
    </>
  );
};

export default FlatsExpandedRow;
